import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommBodyMoisturizerIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M7.91667 3C7.91667 2.58579 8.25245 2.25 8.66667 2.25L13.6667 2.25C14.0809 2.25 14.4167 2.58579 14.4167 3V5.67857H15.3333C15.7475 5.67857 16.0833 6.01436 16.0833 6.42857V8.25H17C17.4142 8.25 17.75 8.58579 17.75 9V17.5714C17.75 19.8591 15.9416 21.75 13.6667 21.75H10.3333C8.05839 21.75 6.25 19.8591 6.25 17.5714L6.25 9C6.25 8.58579 6.58579 8.25 7 8.25H7.91667V6.42857C7.91667 6.01436 8.25245 5.67857 8.66667 5.67857H9.58333V5.46429H8.66667C8.25245 5.46429 7.91667 5.1285 7.91667 4.71429V3ZM11.0833 5.67857H12.9167V3.75L9.41667 3.75V3.96429L10.3333 3.96429C10.7475 3.96429 11.0833 4.30007 11.0833 4.71429V5.67857ZM9.41667 8.25L14.5833 8.25L14.5833 7.17857L9.41667 7.17857V8.25ZM7.75 9.75L7.75 17.5714C7.75 19.0708 8.92637 20.25 10.3333 20.25H13.6667C15.0736 20.25 16.25 19.0708 16.25 17.5714V9.75L7.75 9.75Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
